import { createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "toggle"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#toggle" }),
  /*#__PURE__*/_createTextVNode(" Toggle ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Click on the below buttons to check toggling indicator state with a simple Javascript code: ", -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_12 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.click($event)), ["prevent"])),
          type: "button",
          class: "btn btn-primary me-10",
          id: "kt_button_1"
        }, [
          _hoisted_6,
          _hoisted_7
        ]),
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.click($event)), ["prevent"])),
          type: "button",
          class: "btn btn-success me-10",
          id: "kt_button_2"
        }, [
          _hoisted_8,
          _hoisted_9
        ]),
        _createVNode("button", {
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.click($event)), ["prevent"])),
          type: "button",
          class: "btn btn-danger me-10",
          id: "kt_button_3"
        }, [
          _hoisted_10,
          _hoisted_11
        ])
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_CodeHighlighter2, null, {
        html: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<button
            type="button"
            class="btn btn-primary me-10"
            id="kt_button_1"
          >
            <span class="indicator-label">
              Submit
            </span>
            <span class="indicator-progress">
              Please wait...
              <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              ></span>
            </span></button
          >`), 1)
        ]),
        js: _withCtx(() => [
          _createTextVNode(_toDisplayString(`// Element to indecate
var button = document.querySelector("#kt_button_1");

// Handle button click event
button.addEventListener("click", function() {
    // Activate indicator
    button.setAttribute("data-kt-indicator", "on");

    // Disable indicator after 3 seconds
    setTimeout(function() {
        button.removeAttribute("data-kt-indicator");
    }, 3000);
});`), 1)
        ]),
        _: 1
      })
    ])
  ]))
}